import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as docUploadSelectors from '@makemydeal/dr-dash-store/selectors/docUploadSelectors';
import * as shopperNotificationsSelectors from '@makemydeal/dr-dash-store/selectors/shopperNotificationsSelectors';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { ACTIVITY_NAME_DOC_UPLOAD } from '@makemydeal/dr-dpm-client';
import { useSelector } from 'react-redux';
import SendToCustomerDialogInterstate from '../../sendToCustomerDialog/SendToCustomerDialog.interstate';
import DealActivityCard from '../DealActivityCard.interstate';
import { useDocUploadShareLink } from '../../hooks/useActivityShareLink';

const name = 'docUpload';

export const DocUploadCard = () => {
    const isDocUploadCompleted = useSelector(docUploadSelectors.isDocUploadCompleted);
    const cardValue = useSelector(docUploadSelectors.getDashboardStatusText);
    const notifications = useSelector((state: StateTree) =>
        shopperNotificationsSelectors.getShopperNotificationsByActivity(state, 'docUpload')
    );
    const docUploadDpmState = useSelector((state: StateTree) =>
        dealXgDetailsSelectors.getDpmStateByActivity(state, ACTIVITY_NAME_DOC_UPLOAD)
    );
    const { shareLink: handleShowDocUploadModal, dialogProps } = useDocUploadShareLink();

    const linkText = notifications.length ? 'Resend Link' : 'Send Link';

    return (
        <div>
            <DealActivityCard
                dpmState={docUploadDpmState}
                name={name}
                cardValue={cardValue}
                completed={isDocUploadCompleted}
                showCardAnchor={true}
                action={handleShowDocUploadModal}
                linkText={linkText}
                data-testid="docUpload-link"
            />

            <SendToCustomerDialogInterstate {...dialogProps} />
        </div>
    );
};
